import Vue, { CreateElement } from 'vue'
import { Prop } from 'vue-property-decorator'
import { H6, Subtitle2 } from '@src/elements/typography/typography'
import { IconLanguageSwitch } from '@src/components/language-switch/language-switch'
import Component from 'vue-class-component'

@Component
export class PortraitSettings extends Vue {

  @Prop({ required: true })
  label: string

  @Prop({ required: true })
  callback: void

  render (h: CreateElement) {
    return (
      <div class='portrait-settings'>
        <H6>{this.label}</H6>
        <IconLanguageSwitch />
        <div class='account-settings'>
          <div ref='portrait-settings-button' slot='button' class='language-label' onClick={this.callback}>
            <div class='switch-label'>
              <Subtitle2>{''}</Subtitle2>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
